<div *ngIf="stat" class="gw-space-y-6">
  <div
    class="gw-grid gw-grid-cols-1 sm:gw-grid-cols-2 xl:gw-grid-cols-4 gw-gap-4"
  >
    <div class="gw-bg-background-elevation-1 gw-rounded-xl gw-p-4">
      <label
        class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >{{
          'features.recipients.statsColumns.incomeGrossVolume' | translate
        }}</label
      >
      <p
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-tabular-nums"
      >
        {{
          stat.incomeGrossVolume
            | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
        }}
      </p>
    </div>
    <div class="gw-bg-background-elevation-1 gw-rounded-xl gw-p-4">
      <label
        class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >{{
          'features.recipients.statsColumns.incomeNetVolume' | translate
        }}</label
      >
      <p
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-tabular-nums"
      >
        {{
          stat.incomeNetVolume | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
        }}
      </p>
    </div>
    <div class="gw-bg-background-elevation-1 gw-rounded-xl gw-p-4">
      <label
        class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >{{ 'features.recipients.statsColumns.avgTicket' | translate }}</label
      >
      <p
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-tabular-nums"
      >
        {{ stat.avgTicket | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
      </p>
    </div>
    <div class="gw-bg-background-elevation-1 gw-rounded-xl gw-p-4">
      <label
        class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >{{
          'features.recipients.statsColumns.approvedInvoiceCount' | translate
        }}</label
      >
      <p
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-tabular-nums"
      >
        {{ stat.approvedInvoiceCount }}
      </p>
    </div>
  </div>

  <div class="gw-grid gw-grid-cols-1 sm:gw-grid-cols-3 gw-gap-4">
    <div class="gw-bg-background-elevation-1 gw-rounded-xl gw-p-4">
      <label
        class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >{{
          'features.recipients.statsOverview.cashOutSettledVolume' | translate
        }}</label
      >
      <p
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-tabular-nums"
      >
        {{
          stat.cashOutSettledVolume
            | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
        }}
      </p>
    </div>
    <div class="gw-bg-background-elevation-1 gw-rounded-xl gw-p-4">
      <label
        class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >{{
          'features.recipients.statsOverview.cashOutCount' | translate
        }}</label
      >
      <p
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-tabular-nums"
      >
        {{ stat.cashOutCount }}
      </p>
    </div>
    <div class="gw-bg-background-elevation-1 gw-rounded-xl gw-p-4">
      <label
        class="gw-text-sm gw-font-medium gw-text-text-secondary gw-block gw-mb-2"
        >{{
          'features.recipients.statsOverview.approvalRate' | translate
        }}</label
      >
      <p
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-tabular-nums"
      >
        {{ stat.approvalRate | percent : '1.0-1' : 'pt-BR' }}
      </p>
    </div>
  </div>

  <section *ngIf="paymentMethodRows.length" class="gw-space-y-3">
    <h3 class="gw-text-base gw-font-semibold gw-text-text-primary gw-m-0">
      {{ 'features.recipients.statsOverview.paymentMethodsTitle' | translate }}
    </h3>
    <div
      class="gw-overflow-x-auto gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-overflow-hidden"
    >
      <table class="gw-w-full gw-table-size-s">
        <thead>
          <tr class="gw-border-b gw-border-border-normal">
            <th
              class="gw-text-left gw-text-xs gw-font-medium gw-text-text-secondary gw-px-4 gw-py-3"
            >
              {{ 'common.table.columns.paymentMethod' | translate }}
            </th>
            <th
              class="gw-text-right gw-text-xs gw-font-medium gw-text-text-secondary gw-px-4 gw-py-3"
            >
              {{ 'features.recipients.statsOverview.invoiceCount' | translate }}
            </th>
            <th
              class="gw-text-right gw-text-xs gw-font-medium gw-text-text-secondary gw-px-4 gw-py-3"
            >
              {{ 'common.table.columns.amount' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of paymentMethodRows"
            class="gw-border-b gw-border-border-normal last:gw-border-b-0"
          >
            <td class="gw-px-4 gw-py-3 gw-text-sm gw-text-text-primary">
              {{ row.method | paymentMethod }}
            </td>
            <td
              class="gw-px-4 gw-py-3 gw-text-sm gw-text-text-primary gw-text-right gw-tabular-nums"
            >
              {{ row.count }}
            </td>
            <td
              class="gw-px-4 gw-py-3 gw-text-sm gw-font-semibold gw-text-text-primary gw-text-right gw-tabular-nums"
            >
              {{ row.volume | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
